import { Params, Settings } from 'app/types';

import { request } from '../config';

const SETTINGS_URL = 'settings';

export function apiGetSettings(data: Params, signal?: AbortSignal): Promise<Settings> {
  return request(
    {
      url: `${SETTINGS_URL}.json`,
      method: 'GET',
      params: { ...data },
      signal,
    },
    (data) => data.model,
  );
}

export function apiUpdateSettings(data: Params, signal?: AbortSignal): Promise<Settings> {
  return request(
    {
      url: `${SETTINGS_URL}.json`,
      method: 'PATCH',
      data: { settings: data },
      signal,
    },
    (data) => data.model,
  );
}
